/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HowItWorksSectionBase from "@/src/components/Sections/Common/HowItWorksSection/HowItWorksSectionBase";
import PenIcon from "@/src/assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "@/src/assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "@/src/assets/icons/traffic/toggleable/IconShakeHands";
const HowItWorksSectionFamilyLaw = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Fall beschreiben",
          description: "Sie registrieren sich und teilen uns kurz mit, wie wir Ihnen helfen können.",
          icon: PenIcon,
        },
        {
          title: "2. Professionelle Erstberatung",
          description: "Wir prüfen Ihren Fall und rufen Sie zu der von Ihnen gewünschten Uhrzeit an.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Weitere Schritte einleiten",
          description: "Wir besprechen Ihre Möglichkeiten und Sie entscheiden sich, wie Sie weiter vorgehen möchten.",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionFamilyLaw;
